<template>
  <div class="content-wrapper reporting-container">
    <!-- Section Header -->
    <div class="section-header d-flex justify-content-between align-items-center">
      <div class="section-header__content d-flex">
        <h1 class="section-header__content__title">Reporting</h1>
      </div>
    </div>

    <loading-skeleton
      v-if="preloader"
      class="reporting-skeleton"
      type="table"
      :table="{ headItems: 4, bodyItems: 3, filters: false }"
    />

    <div v-show="!preloader" class="reporting-wrapper">
      <!--FILTER-->
      <div class="reporting-filters optimizer-card">
        <reporting-filter
          @filter="(_filter, _reportingMode) => {filter = _filter; reportingMode = _reportingMode}"
          @ready="preloader = false"
          :submiting="submiting"
          :is-submitting-report="submitingReport"
        />
      </div>

      <!--TABLE-->
      <div v-if="filter && reportingMode === 'submit'" class="reporting-table-wrapper">
        <!-- <div class="row">
          <h5 style="margin: 0px;" class="col-5 col-sm-3 mr-auto">{{ filter.trafficSourceType }}
            {{ filter.reportType.name || filter.reportType.reportType }}</h5>
        </div> -->
        <div>
          <loading-skeleton
            v-if="tablePreloader"
            type="table"
            :table="{ headItems: 6, bodyItems: 20, filters: true, search: true, filterItems: 1 }"
          />
          <div v-else-if="table.fields.length > 0" class="optimizer-table reporting-table">
            <vue-opti-table-light
              :name="$c_tableName"
              class="report-table-wrapper"
              :hover="true"
              :export-label="$c_exportLabel"
              :selectable="false"
              select-label="Rows"
              :header-fields="$c_tableHeaders"
              :totals="table.totals"
              :items="table.items"
              v-model="tableModel"
              :sort="{ key: 'cost', order: 'desc' }"
              :default-rows="100"
              :save-settings="$_saveSettings"
              sticky
            >
              <template slot="search">
                <div class="col-auto reporting-table__title">
                  <h5>{{ filter.trafficSourceType }} {{ filter.reportType.name || filter.reportType.reportType }}</h5>
                </div>
              </template>

              <template slot="content_preview" slot-scope="props">
                <a target="_blank" :href="props.item.url">
                  <div class="content-preview">
                    <div class="content-image pull-left">
                      <img :src="uiHelper.table.urlFix(props.item.image_url)" @error="$_imageError" />
                    </div>
                    <div class="content-text pull-left">
                      <b>{{ props.item.headline }}</b>
                    </div>
                  </div>
                </a>
              </template>
              <template slot="creative_preview" slot-scope="props">
                <div class="creative-preview">
                  <div class="creative-image pull-left" v-if="props.item.details.image">
                    <img style="width:60px" :src="props.item.details.image" />
                  </div>
                  <div class="creative-image pull-left" v-else-if="props.item.details.icon">
                    <img style="width:60px" :src="props.item.details.icon" />
                  </div>
                  <div class="creative-text pull-left">
                    <b>{{ props.item.details.title }}</b>
                    <small v-if="props.item.details.description" class="brandname d-block">{{ props.item.details.description }}</small>
                  </div>
                </div>
              </template>
              <template slot="status" slot-scope="props">
                <span class="status-item" v-b-tooltip.hover.topright :title="props.item.status"
                      v-html="uiHelper.content.status(props.item.status)"
                >
                </span>
              </template>
            </vue-opti-table-light>
          </div>
        </div>
      </div>


      <!-- SAVED REPORTS TABLE-->
      <div v-if="filter && reportingMode === 'savedReports'" class="saved-reports-table-wrapper">
        <loading-skeleton
          v-if="tablePreloader"
          type="table"
          :table="{ headItems: 6, bodyItems: 20, filters: true, search: true, filterItems: 1 }"
        />
        <div v-else-if="CSVtable.fields.length > 0" class="optimizer-table saved-reports-table">
          <vue-opti-table-light
            :name="$c_savedReportstableName"
            class="report-table-wrapper"
            :hover="true"
            :export-label="$c_CSVreportsExportLabel"
            :selectable="false"
            select-label="Rows"
            :header-fields="CSVtable.fields"
            :items="CSVtable.items"
            v-model="tableModel"
            :sort="{ key: 'date', order: 'desc' }"
            :default-rows="100"
            :save-settings="$_saveSettings"
          >
            <template slot="search">
              <div class="col saved-reports-table__title d-flex justify-content-between pr-0">
                <h5>Your saved reports</h5>
                <b-btn class="secondary-button" @click="$_loadSavedReports" title="Refresh"><i class="fa fa-refresh"></i></b-btn>
              </div>
            </template>
            <template slot="url" slot-scope="props">
              <b-link @click="$_downloadFile(props.item.url)">{{ props.item.name }}</b-link>
            </template>
            <template slot="status" slot-scope="props">
              <span v-if="props.item.status == 1" class="status-item status-item-enabled">
                <span class="circle" /> Uploaded</span>
              <span v-else-if="props.item.status == 0" class="status-item status-item-disabled">
                <span class="circle" /> Uploading</span>
              <span v-else-if="props.item.status == -1" class="status-item status-item-deleted">
                <span class="circle" /> Failed</span>
            </template>
          </vue-opti-table-light>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LoadingSkeleton from '@sh/components/Utils/Skeleton/LoadingSkeleton.vue';
import tableFields from '@/helpers/fields/index';
import uiHelper from '@sh/helpers/ui';
import notifications from '@sh/mixins/notifications';
import tableMixins from '@sh/mixins/table';
import reportingFilter from './Filter';
import configFile from './config';

export default {
  name: 'Reporting',
  components: { reportingFilter, LoadingSkeleton },
  mixins: [notifications, tableMixins],
  data() {
    return {
      config: null,
      uiHelper,
      preloader: true,
      tablePreloader: true,
      filter: null,
      reportingMode: null,
      tableModel: {
        selectedRows: [],
        displayColumns: [],
        columnsOrder: [],
      },
      table: {
        fields: [],
        items: [],
        totals: {},
      },
      CSVtable: {
        fields: [
          {
            header: { content: 'Date', style: '' },
            display: true,
            item: {
              key: 'date',
              sortable: true,
              content: (item) => item.date.replace(/T/, ' ').replace(/\..+/, ''),
              style: { textAlign: 'center', position: 'relative' },
            },
          },
          {
            header: { content: 'URL', style: '' },
            display: true,
            item: {
              key: 'url',
              slot: 'url',
              sortable: true,
              content: (item) => item.url,
              style: { textAlign: 'center', position: 'relative' },
            },
          },
          {
            header: { content: 'Status', style: '' },
            display: true,
            item: {
              key: 'status',
              slot: 'status',
              sortable: true,
              content: (item) => item.status,
              style: { textAlign: 'center', position: 'relative' },
            },
          },
        ],
        items: [],
      },
      submiting: false,
      submitingReport: false,
    };
  },
  computed: {
    $c_tableHeaders() {
      return this.$_getFieldInfo(this.table.fields);
    },
    $c_tableName() {
      return this.filter ? `${this.filter.type}${this.filter.reportType.reportType}ReportTable` : 'reportTable';
    },
    $c_savedReportstableName() {
      return 'savedReportsTable';
    },
    $c_exportLabel() {
      return `${this.filter.trafficSourceType}_${this.filter.reportType.reportType}_performance_report_${this.filter.dateRange.startDate}_${this.filter.dateRange.endDate}`;
    },
    $c_CSVreportsExportLabel() {
      return 'saved_reports';
    },
  },
  watch: {
    filter: {
      immediate: true,
      handler(filter) {
        if (filter && this.reportingMode === 'submit') {
          this.$_loadReportTable();
        } else if (filter && this.reportingMode === 'savedReports') {
          this.$_loadSavedReports();
        }
      },
      deep: true,
    },
  },
  async created() {
    this.config = await configFile.getConfig();
    // this.preloader = false
  },
  methods: {
    async $_downloadFile(url) {
      window.open(url, '_blank');
    },
    async $_loadReportTable() {
      // Load Table
      this.submiting = true;
      this.tablePreloader = true;
      this.table.fields = [];
      this.table.items = [];
      this.table.totals = {};
      this.tableModel.selectedRows = [];
      this.tableModel.displayColumns = [];
      this.tableModel.columnsOrder = [];
      let rawResponse = [];

      try {
        rawResponse = await this.config.api.reporting.get(this.filter.trafficSourceType, this.filter.reportType.reportType, this.filter.campaignsId, this.filter.dateRange.startDate, this.filter.dateRange.endDate);
        if (Object.keys(rawResponse).length > 0) {
          rawResponse.fields.forEach((item) => {
            this.table.fields.push(tableFields.getField(this.filter.reportType.fieldsDomain, {
              name: item.item.key,
              uniqueName: this.filter.trafficSourceType,
            }, item));
          });
          this.table.items = rawResponse.items;
          this.table.totals = { ...rawResponse.totals, traffic_source_item_id: `Total: ${rawResponse.totals.total_results}`, totalElements: rawResponse.totals.total_results };
        }
      } catch (error) {
        this.$n_failNotification({ title: (error?.response?.data?.message) || 'An error occurred' });
      }
      this.tablePreloader = false;
      this.submiting = false;
    },
    async $_loadSavedReports() {
      // Load Saved Reports Table
      // this.submiting = true
      this.tablePreloader = true;
      this.CSVtable.items = [];
      this.tableModel.selectedRows = [];
      this.tableModel.displayColumns = [];
      this.tableModel.columnsOrder = [];
      let rawResponse = [];

      try {
        rawResponse = await this.config.api.reporting.backgroundReporting(this.filter.reportType);
      } catch (error) {
        this.$n_failNotification({ title: error.response.data.message || 'An error occurred' });
      }
      this.CSVtable.items = rawResponse.items;
      this.tablePreloader = false;
      // this.submiting = false
    },
    $_imageError(event) {
      const eventTarget = event.target;

      if (!eventTarget.dataset.image_error) {
        eventTarget.dataset.image_error = 'true';
        eventTarget.src = '/sh_static/other/no-image.jpeg';
      }
    },
    async $_saveSettings(fields) {
      return this.$_saveSettingsOptionsReporting(fields, {
        type: this.filter.trafficSourceType,
        level: this.filter.reportType.reportType,
      }, true);
    },
  },
};
</script>

<style lang="scss">
  .reporting-container {
    .section-header {
      margin-bottom: 1.5rem;
    }

    .reporting-table-wrapper,
    .saved-reports-table-wrapper {
      margin-top: 4rem;
    }

    .reporting-table,
    .saved-reports-table {
      &__title {
        display: flex;
        align-items: center;

        h5 {
          color: $text-primary;
          font-size: 1.7rem;
        }

        .secondary-button {
          min-width: unset;
          i {
            margin: 0;
          }
        }
      }
    }

    .reporting-skeleton {
      .optimizer-skeleton-table {
        &__head {
          &__data {
            width: 23%;
            height: 2.8rem;
          }
        }

        &__body {
          &__data {
            margin-bottom: 2rem;

            &:last-of-type {
              margin-bottom: 0;
            }
          }
        }
      }
    }

  }

  .report-table-wrapper {
    .content-preview {
      display: flex;
      max-width: 330px;
      white-space: normal;

      .content-image {
        margin-right: 10px;

        img {
          max-height: 75px;
          max-width: 100px;
        }
      }

      .content-text {
        width: 200px;
      }
    }
  }
</style>
